/**
 * Модуль хранилища PageRegularDelivery
 * @module PageRegularDelivery/Store/Zones
 * */

import Vue from 'vue'
import * as locationsService from 'API/locations'

/**
 * Зона доставки
 * @typedef {Object} Area
 * @property {Date} createdAt - createdAt
 * @property {Date} deletedAt - deletedAt
 * @property {Date} updatedAt - updatedAt
 * @property {String} description - description
 * @property {String} id - id
 * @property {Boolean} isHidden - isHidden
 * @property {String} name - name
 * @property {String} regionId - regionId
 * @property {String} type - type
 * */

/**
 * Зона доставки
 * @typedef {Object} Zone
 * @property {String} description - description
 * @property {String} id - id
 * @property {String} name - name
 * @property {Array.<Object>} polygon - polygon
 * */

export default {
  namespaced: true,
  state: () => ({
    zones: []
  }),
  getters: {
    deserializeZone: () => (area) => ({
      description: area.description,
      id: area.id,
      name: area.name,
      polygon: area.points
    })
  },
  actions: {
    async getZones({ commit, getters }, storeId) {
      try {
        const { data } = await locationsService.getShopAreas(storeId)
        commit('setZones', data.list?.[0]?.areas.map(zone => getters.deserializeZone(zone)) ?? [])
      } catch (e) {
        console.error(e)
        throw e
      }
    },
    async removeZone({ commit, state }, zoneId) {
      try {
        await locationsService.deleteArea(zoneId)
        commit('setZones', state.zones.filter(zone => zone.id !== zoneId))
      } catch (e) {
        console.error(e)
        throw e
      }
    }
  },
  mutations: {
    setZones(state, zones) {
      Vue.set(state, 'zones', zones)
    }
  }
}
